import React from 'react';
import { useTranslation } from 'react-i18next';

interface PowerOutageScheduleMemoProps {
  testId?: string;
  className?: string;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export const PowerOutageScheduleMemo: React.FC<
  PowerOutageScheduleMemoProps
> = ({ testId, className, onChange }) => {
  const { t } = useTranslation();
  return (
    <div data-testid={testId} className={`${className}`}>
      <p
        className="noto-13-semibold leading-[23px] text-dark-3"
        data-testid={`${testId}-title`}
      >
        {t('overview.modal.memo')}
      </p>
      <textarea
        className="noto-normal-3 mt-[5px] h-[66px] w-full resize-none rounded-[5px] border border-light-6 bg-white p-[10px] leading-none placeholder:text-light-5 focus:outline-none"
        data-testid={`${testId}-body`}
        onChange={onChange}
        placeholder={t('overview.modal.memo', { context: 'placeholder' })}
      ></textarea>
    </div>
  );
};
